<div class="produto-item" [class.produto-oculto]="!produto.visivel" (click)="editar.emit(produto)">
  <!-- Drag Handle -->
  <div cdkDragHandle class="drag-handle" (click)="$event.stopPropagation()">
    <i class="pi pi-ellipsis-v"></i>
    <i class="pi pi-ellipsis-v"></i>
  </div>

  <!-- Thumbnail -->
  <div class="produto-thumbnail">
    <img *ngIf="produto.foto || produto.fotoUrl" [src]="produto.fotoUrl || produto.foto" alt="{{ produto.nome }}" />
    <div *ngIf="!produto.foto && !produto.fotoUrl" class="thumbnail-placeholder">
      <i class="pi pi-image"></i>
    </div>
  </div>

  <!-- Info -->
  <div class="produto-info">
    <span class="produto-nome">{{ produto.nome }}</span>
    <span *ngIf="variantesLabel" class="produto-variantes">{{ variantesLabel }}</span>
  </div>

  <!-- Preco -->
  <div class="produto-preco">
    <span *ngIf="produto.precoPromocional" class="preco-original">
      {{ produto.preco | currency:moedaSimbolo:'symbol-narrow':'1.0-0':moedaLocal }}
    </span>
    <span class="preco-atual" [class.preco-promocional]="produto.precoPromocional">
      {{ (produto.precoPromocional || produto.preco) | currency:moedaSimbolo:'symbol-narrow':'1.0-0':moedaLocal }}
    </span>
  </div>

  <!-- Visibilidade -->
  <button pButton
          type="button"
          [icon]="visibilidadeIcon"
          class="p-button-rounded p-button-text p-button-sm visibilidade-btn"
          [class.visibilidade-oculto]="!produto.visivel"
          [pTooltip]="visibilidadeTooltip"
          (click)="$event.stopPropagation(); toggleVisibilidade.emit(produto)">
  </button>

  <!-- Menu 3 pontos -->
  <button pButton
          type="button"
          icon="pi pi-ellipsis-h"
          class="p-button-rounded p-button-text p-button-sm"
          (click)="$event.stopPropagation(); prodMenu.toggle($event)">
  </button>
  <p-menu #prodMenu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
</div>
